import React from 'react';
import {Modal, Button} from 'react-bootstrap';
import { connect } from 'react-redux';

class Contact extends React.Component {
    constructor(props) {
        super(props)
        this.state ={
            showModal: props.showModal
        }
        this.handleClose = this.handleClose.bind(this);
        
    }
handleClose(){
    this.setState({
        showModal: false
    })
    this.props.handleClose();
}

componentWillReceiveProps(nextProps){
this.setState({
    showModal: nextProps.showModal
})
}

    
 render() {
    const underwriters = this.props.contactUnderWriter;
    underwriters.sort((a,b)=>a.sortOrder-b.sortOrder)
     return (<div >        
        <Modal backdropClassName="modal-backdrop-contact" dialogClassName="modal-dialog-contact" show={this.state.showModal} onHide={this.handleClose}>
          <Modal.Header className="modal-header-contact">
          </Modal.Header>
          <Modal.Body className="modal-body-contact" ><p style={{fontSize:"1.25em"}}>For Quick Assistance</p>
          <p>Please contact one of the following underwriters</p>{!!underwriters && underwriters.length>0 && underwriters.map(uw => {
              const mailto = `mailto:${uw.email}`;
              return (<ul><li style={{listStyleType:"none"}}>{uw.firstName} {uw.lastName} at</li>
              <li style={{listStyleType:"none", fontWeight:"bold", marginLeft:"12px"}}><i className="fa fa-envelope" style={{paddingRight:"5px"}}></i><a href={mailto} style={{color:"#040404"}}>{uw.email}</a></li>
              <li style={{listStyleType:"none", fontWeight:"bold", marginLeft:"12px", fontStyle:"italic"}}><i className="fa fa-phone" style={{paddingRight:"5px"}}></i>+ {uw.phoneExt} {uw.phone}</li>
          </ul>)})}</Modal.Body>
        </Modal>
      </div>)
    
 }
 }
 const mapStateToProps = state =>({
    contactUnderWriter: state.auth.contactUnderWriter
  })
  
  export default connect(mapStateToProps) (Contact)